var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2084 13.2917C17.246 13.2917 19.7084 10.8292 19.7084 7.79166C19.7084 4.75409 17.246 2.29166 14.2084 2.29166C11.1709 2.29166 8.70841 4.75409 8.70841 7.79166C8.70841 8.5987 8.88223 9.36511 9.19452 10.0555L2.29175 16.9583V19.7083H5.04175V17.875H6.87508V16.0417H8.70841L11.9445 12.8055C12.635 13.1179 13.4014 13.2917 14.2084 13.2917Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 5.95834L15.125 6.87501",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.4d09ce9091bd77f07f5551cd51b28a7d.svg";
export { ForwardRef as ReactComponent };